import React from "react";
import { rotateOcrPoint } from "../utils/ocrSearch";

export const OcrSearchStatus = ({ search, query, mode, arabic = false }) => {
  if (search.status === "idle") return null;
  const message = search.status === "loading"
    ? (arabic ? "جارٍ تحميل مواضع الكلمات…" : "Loading word highlights…")
    : search.status === "unavailable"
      ? (arabic ? "تمييز البحث غير متاح لهذه الصفحة." : "Search highlighting is unavailable for this page.")
      : (arabic ? `مواضع ${mode === "exact" ? "مطابقة تامة" : "مطابقة"}: ${search.matches.length}`
        : `${search.matches.length} ${mode === "exact" ? "exact phrase matches" : "matching words"}`);
  return <div role="status" style={{ padding: "6px 12px" }}>{message}
    {search.status === "ready" && query && <> — <bdi>{query}</bdi></>}
  </div>;
};

export default function OcrSearchHighlights({ search, pageIndex, rotation = 0, width, height }) {
  const page = search.data?.pages.find(item => item.page_index === pageIndex);
  if (!page) return null;
  const swapped = Math.abs(rotation % 180) === 90;
  const expectedRatio = swapped ? page.height / page.width : page.width / page.height;
  // A differently cropped page cannot be aligned just by scaling coordinates.
  if (Math.abs(width / height / expectedRatio - 1) > 0.01) {
    return <div role="status" style={{ position: "absolute", top: 0, background: "#fff3cd", zIndex: 3 }}>
      {localStorage.getItem("lang") === "ar" ? "مواضع الكلمات لا تتوافق مع أبعاد هذه الصفحة." : "Word highlights do not match this page’s dimensions."}
    </div>;
  }
  return <svg data-testid="ocr-search-overlay" viewBox="0 0 1 1" preserveAspectRatio="none"
    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none", zIndex: 3 }}>
    {search.matches.filter(match => match.pageIndex === pageIndex).map((match, index) =>
      <g key={index} className="ocr-search-match" aria-label={match.text}>
        <title>{match.text}</title>
        {match.polygons.map((polygon, wordIndex) => <polygon key={wordIndex}
          points={polygon.map(point => { const p = rotateOcrPoint(point, rotation); return `${p.x},${p.y}`; }).join(" ")}
          fill="rgba(255, 200, 0, 0.4)" />)}
      </g>)}
  </svg>;
}
